import React, { FunctionComponent } from "react";
import { Chip, ChipProps, createStyles, Theme } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { StoreOrderState as State } from "../../../models/Store";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    proposed: {
      color: "red",
      borderColor: "red"
    },
    confirmed: {
      color: "orange",
      borderColor: "orange"
    },
    ordered: {
      color: "grey",
      borderColor: "grey"
    },
    delivered: {
      color: "green",
      borderColor: "green"
    }
  })
);

interface StoreOrderStateProps extends ChipProps {
  state: State;
}

export const StoreOrderState: FunctionComponent<StoreOrderStateProps> = ({
  state,
  ...props
}) => {
  const classes = useStyles();
  return (
    <Chip
      {...props}
      size="small"
      variant={"outlined"}
      label={state}
      className={
        state === State.Proposed
          ? classes.proposed
          : state === State.Confirmed
          ? classes.confirmed
          : state === State.Ordered
          ? classes.ordered
          : classes.delivered
      }
    />
  );
};
